import { useEffect } from "react";
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_IMAGE,
  DEFAULT_TITLE,
  SITE_URL,
  toAbsoluteUrl,
} from "../utils/siteSeo";

function upsertMeta(attributeName, attributeValue, content) {
  let tag = document.head.querySelector(
    `meta[${attributeName}="${attributeValue}"]`
  );

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attributeName, attributeValue);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
}

function upsertCanonical(href) {
  let tag = document.head.querySelector('link[rel="canonical"]');

  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }

  tag.setAttribute("href", href);
}

function applyRobots(noindex) {
  const tag = document.head.querySelector('meta[name="robots"]');

  if (!noindex) {
    if (tag) tag.remove();
    return;
  }

  upsertMeta("name", "robots", "noindex, nofollow");
}

function applySeo({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  path = "/",
  type = "website",
  noindex = false,
}) {
  const canonicalUrl = /^https?:\/\//i.test(path)
    ? path
    : new URL(path.startsWith("/") ? path : `/${path}`, SITE_URL).toString();
  const imageUrl = toAbsoluteUrl(image);
  const twitterCard =
    imageUrl === toAbsoluteUrl(DEFAULT_IMAGE)
      ? "summary"
      : "summary_large_image";

  document.title = title;
  upsertMeta("name", "description", description);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:image", imageUrl);
  upsertMeta("property", "og:url", canonicalUrl);
  upsertMeta("property", "og:type", type);
  upsertMeta("name", "twitter:card", twitterCard);
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", imageUrl);
  upsertCanonical(canonicalUrl);
  applyRobots(noindex);
}

export default function PageSeo(props) {
  const { title, description, image, path, type, noindex } = props;

  useEffect(() => {
    applySeo({ title, description, image, path, type, noindex });

    return () => {
      applySeo({
        title: DEFAULT_TITLE,
        description: DEFAULT_DESCRIPTION,
        image: DEFAULT_IMAGE,
        path: "/",
      });
    };
  }, [description, image, path, title, type, noindex]);

  return null;
}
